import { render, staticRenderFns } from "./imageGalleryModal.vue?vue&type=template&id=49edb3c4&"
import script from "./imageGalleryModal.vue?vue&type=script&lang=ts&"
export * from "./imageGalleryModal.vue?vue&type=script&lang=ts&"
import style0 from "./imageGalleryModal.vue?vue&type=style&index=0&id=49edb3c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports